import * as actionTypes from '../actions/actionTypes';

const initialState = {
    message: null,
    popUpMessage: null,
    showModal: false,
    modifyDetails: false,
    portals: null,
    portalsInfo: null,
    portalsLoading: true,
    portalInfoLoading: false,
    selectedLangInfo: null,
    processing: false
}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.MODIFY_ACCOUNT_START:
            return {
                ...state,
                processing: true,
                message: null,
                showModal: false,
                modifyDetails: true
            }
        case actionTypes.MODIFY_ACCOUNT_SUCCESS:
            return {
                ...state,
                processing: false,
                showModal: false,
                modifyDetails: false
            }
        case actionTypes.MODIFY_ACCOUNT_FAILURE:
            return {
                ...state,
                processing: false,
                showModal: false,
                modifyDetails: false,
                message: {type: "Error", info: action.error}
            }
        case actionTypes.SET_PERSINFO_DISPLAY_MESSAGE:
            return {
                ...state,
                message: action.message
            }
        case actionTypes.SET_MEMPOPUP_DISPLAY_MESSAGE:
            return {
                ...state,
                popUpMessage: action.popUpMessage
            }
        case actionTypes.FETCH_MEMBER_ACCOUNT_PORTALS_START:
            return {
                ...state,
                portalsLoading: true
            }
        case actionTypes.FETCH_MEMBER_ACCOUNT_PORTALS_SUCCESS:
            return {
                ...state,
                portals: action.portals,
                portalsLoading: false
            }
        case actionTypes.FETCH_MEMBER_ACCOUNT_PORTALS_FAILURE:
            return {
                ...state,
                portalsLoading: false
            }

        case actionTypes.FETCH_LANGUAGE_INFO_SUCCESS:
            return {
                ...state,
                portalsInfo: {
                    ...state.portalsInfo,
                    ...(action.portalInfo 
                        ? Object.values(action.portalInfo).reduce((acc, portal) => {
                            if(portal && portal.portalShortName) {
                                acc[portal.portalShortName] = portal;
                            }
                            return acc;
                          }, {})
                        : {})
                },
                portalInfoLoading: false
            }
        case actionTypes.FETCH_LANGUAGE_INFO_FAILURE:
            return {
                ...state,
                error: action.error,
                portalInfoLoading: false
            }
        case actionTypes.MERGE_PORTALS_LIST_ADMIN:
            return {
                ...state,
                portalsInfo: action.portalInfo
            }
        default:
            return {
                ...state
            }
    }
}

export default reducer;